<mat-table #table [dataSource]="dataSource" matSort matSortActive="created_at" matSortDirection="desc" matSortDisableClear
    [@animateStagger]="{value:'50'}">

    <!-- Employee Complaint Name Column -->
    <ng-container matColumnDef="complaint">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Complaint' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let complaint">
            <p class="text-truncate font-weight-600" [matTooltip]="complaint.complaint">{{complaint.complaint}}</p>
        </mat-cell>
    </ng-container>

    <!-- Comment Column -->
    <ng-container matColumnDef="complaint_category_name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Complaint category' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let complaint">
            <p class="text-truncate font-weight-600" matTooltipClass="tooltip" [matTooltip]="complaint.complaint_category_name">{{complaint.complaint_category_name}}</p>
        </mat-cell>
    </ng-container>

    <!-- Status Column -->
    <!-- <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Status' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let complaint">
            <p class="text-truncate font-weight-600">{{complaint.status}}</p>
        </mat-cell>
    </ng-container> -->

    <!-- Created at Column -->
    <ng-container matColumnDef="created_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide.xs>{{'Date of Creation' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let complaint" fxHide.xs>
            <p class="text-truncate font-weight-600">{{complaint.created_at}}</p>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let complaint; columns: displayedColumns;" class="complaint" matRipple
        [@animate]="{value:'*',params:{y:'100%'}}">
    </mat-row>

</mat-table>
<mat-paginator #paginator [length]="totalElements" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]"
    [hidePageSize]="true" [fxHide]="totalElements === 0">
</mat-paginator>